/* VCTparts: compare dashcams on collection and search pages.
   Cards of products with the metafield vct.vergelijk carry their data in
   data-vct-cmp (snippets/product-item.liquid) and get a "Vergelijk" tick.
   Up to 3 products are kept in sessionStorage, so the choice survives
   paging and filtering; a bar at the bottom opens the comparison table.
   Only what the metafield holds is shown ("–" = not stated); rows that no
   chosen product fills are left out. Styling: assets/vct-modern.css
   section 17. */
(function () {
  'use strict';

  var KEY = 'vct-cmp';
  var MAX = 3;
  var LANG = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var T = {
    nl: {
      compare: 'Vergelijk', compareN: 'Vergelijk ({n})', clear: 'Wissen', title: 'Dashcams vergelijken',
      pickMore: 'Kies nog een dashcam om te vergelijken', max: 'Je kunt maximaal 3 dashcams vergelijken',
      close: 'Sluiten', remove: 'Verwijderen', view: 'Bekijk', price: 'Prijs',
      cams: "Camera's", front: 'Resolutie voorcamera', rear: 'Resolutie achtercamera', interior: 'Interieurcamera',
      wifi: 'WiFi en app', gps: 'GPS', screen: 'Scherm', parking: 'Parkeerbewaking', night: 'Nachtzicht',
      fov: 'Kijkhoek', sd: 'Geheugenkaart', gsensor: 'Botsdetectie (G-sensor)', hardwire: 'Continue voeding meegeleverd',
      cam1: '1 (voor)', cam2: '2 (voor + achter)', cam3: '3 (voor, achter en interieur)',
      yes: 'Ja', builtIn: 'Ingebouwd', ir: 'Infrarood', mode: 'Nachtmodus', inch: 'inch', sdUpTo: 'microSD tot {n} GB',
      parkingHw: 'Ja, met continue voeding (los verkrijgbaar)',
      note: '– = niet vermeld in de productinformatie. Controleer de productpagina voor alle details.'
    },
    de: {
      compare: 'Vergleichen', compareN: 'Vergleichen ({n})', clear: 'Leeren', title: 'Dashcams vergleichen',
      pickMore: 'Wähle noch eine Dashcam zum Vergleichen', max: 'Du kannst maximal 3 Dashcams vergleichen',
      close: 'Schließen', remove: 'Entfernen', view: 'Ansehen', price: 'Preis',
      cams: 'Kameras', front: 'Auflösung Frontkamera', rear: 'Auflösung Heckkamera', interior: 'Innenraumkamera',
      wifi: 'WLAN und App', gps: 'GPS', screen: 'Display', parking: 'Parküberwachung', night: 'Nachtsicht',
      fov: 'Blickwinkel', sd: 'Speicherkarte', gsensor: 'Aufprallerkennung (G-Sensor)', hardwire: 'Dauerstromkabel enthalten',
      cam1: '1 (vorne)', cam2: '2 (vorne + hinten)', cam3: '3 (vorne, hinten und Innenraum)',
      yes: 'Ja', builtIn: 'Integriert', ir: 'Infrarot', mode: 'Nachtmodus', inch: 'Zoll', sdUpTo: 'microSD bis {n} GB',
      parkingHw: 'Ja, mit Dauerstromkabel (separat erhältlich)',
      note: '– = in den Produktinformationen nicht angegeben. Alle Details findest du auf der Produktseite.'
    },
    fr: {
      compare: 'Comparer', compareN: 'Comparer ({n})', clear: 'Effacer', title: 'Comparer les dashcams',
      pickMore: 'Choisissez encore une dashcam à comparer', max: 'Vous pouvez comparer 3 dashcams au maximum',
      close: 'Fermer', remove: 'Retirer', view: 'Voir', price: 'Prix',
      cams: 'Caméras', front: 'Résolution caméra avant', rear: 'Résolution caméra arrière', interior: 'Caméra intérieure',
      wifi: 'Wi-Fi et appli', gps: 'GPS', screen: 'Écran', parking: 'Surveillance parking', night: 'Vision nocturne',
      fov: 'Angle de vue', sd: 'Carte mémoire', gsensor: 'Détection de choc (G-sensor)', hardwire: 'Alimentation permanente incluse',
      cam1: '1 (avant)', cam2: '2 (avant + arrière)', cam3: '3 (avant, arrière et intérieur)',
      yes: 'Oui', builtIn: 'Intégré', ir: 'Infrarouge', mode: 'Mode nuit', inch: 'pouces', sdUpTo: 'microSD jusqu’à {n} Go',
      parkingHw: 'Oui, avec alimentation permanente (vendue séparément)',
      note: '– = non indiqué dans les informations produit. Consultez la page produit pour tous les détails.'
    },
    en: {
      compare: 'Compare', compareN: 'Compare ({n})', clear: 'Clear', title: 'Compare dashcams',
      pickMore: 'Pick one more dashcam to compare', max: 'You can compare up to 3 dashcams',
      close: 'Close', remove: 'Remove', view: 'View', price: 'Price',
      cams: 'Cameras', front: 'Front camera resolution', rear: 'Rear camera resolution', interior: 'Interior camera',
      wifi: 'Wi-Fi and app', gps: 'GPS', screen: 'Screen', parking: 'Parking mode', night: 'Night vision',
      fov: 'Field of view', sd: 'Memory card', gsensor: 'Impact detection (G-sensor)', hardwire: 'Hardwire kit included',
      cam1: '1 (front)', cam2: '2 (front + rear)', cam3: '3 (front, rear and interior)',
      yes: 'Yes', builtIn: 'Built in', ir: 'Infrared', mode: 'Night mode', inch: 'inch', sdUpTo: 'microSD up to {n} GB',
      parkingHw: 'Yes, with hardwire kit (sold separately)',
      note: '– = not stated in the product information. See the product page for all details.'
    }
  };
  var t = T[LANG] || T.nl;
  var ROWS = ['cams', 'front', 'rear', 'interior', 'wifi', 'gps', 'screen', 'parking', 'night', 'fov', 'sd', 'gsensor', 'hardwire'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function load() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; }
  }
  function save(list) {
    try { sessionStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function num(n) {
    return LANG === 'en' ? String(n) : String(n).replace('.', ',');
  }
  function cell(key, s) {
    var v = s ? s[key] : null;
    if (v == null || v === false || v === '') return null;
    switch (key) {
      case 'cams': return t['cam' + v] || String(v);
      case 'wifi': case 'gsensor': case 'hardwire': return t.yes;
      case 'gps': return t.builtIn;
      case 'screen': return num(v) + ' ' + t.inch;
      case 'parking': return s.parking_note === 'hardwire' ? t.parkingHw : t.yes;
      case 'night': return v === 'ir' ? t.ir : v === 'mode' ? t.mode : String(v);
      case 'sd': return t.sdUpTo.replace('{n}', v);
      default: return String(v);
    }
  }

  /* ---- Cards ------------------------------------------------------------ */

  function cardData(card) {
    try { return JSON.parse(card.getAttribute('data-vct-cmp')); } catch (e) { return null; }
  }
  function syncToggles() {
    var chosen = load().map(function (p) { return p.h; });
    var boxes = document.querySelectorAll('[data-vct-cmp-toggle]');
    for (var i = 0; i < boxes.length; i++) {
      var on = chosen.indexOf(boxes[i].value) > -1;
      if (boxes[i].checked !== on) boxes[i].checked = on;
      boxes[i].closest('.vct-cmp-toggle').classList.toggle('is-on', on);
    }
  }

  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.hasAttribute || !box.hasAttribute('data-vct-cmp-toggle')) return;
    var card = box.closest('[data-vct-cmp]');
    var data = card && cardData(card);
    var list = load().filter(function (p) { return p.h !== box.value; });
    if (box.checked && data) {
      if (list.length >= MAX) {
        box.checked = false;
        flash(t.max);
        return;
      }
      list.push(data);
    }
    save(list);
    syncToggles();
    renderBar();
  });
  /* ---- Bar ----------------------------------------------------------------- */

  var bar = null;
  var flashTimer = null;
  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'vct-cmp-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', t.title);
    bar.hidden = true;
    document.body.appendChild(bar);
    bar.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-vct-cmp-remove]');
      if (rm) {
        save(load().filter(function (p) { return p.h !== rm.getAttribute('data-vct-cmp-remove'); }));
        syncToggles();
        renderBar();
        return;
      }
      if (e.target.closest('[data-vct-cmp-clear]')) {
        save([]);
        syncToggles();
        renderBar();
        return;
      }
      if (e.target.closest('[data-vct-cmp-open]')) openTable();
    });
    return bar;
  }
  function renderBar() {
    var list = load();
    var el = ensureBar();
    if (!list.length) { el.hidden = true; document.documentElement.classList.remove('vct-cmp-open'); return; }
    var thumbs = list.map(function (p) {
      return '<li><img src="' + esc(p.i) + '" alt="" width="48" height="48" loading="lazy"><span>' + esc(p.t) + '</span>' +
        '<button type="button" data-vct-cmp-remove="' + esc(p.h) + '" aria-label="' + esc(t.remove + ': ' + p.t) + '">×</button></li>';
    }).join('');
    for (var i = list.length; i < MAX; i++) thumbs += '<li class="is-empty" aria-hidden="true"></li>';
    el.innerHTML =
      '<ul class="vct-cmp-bar__items">' + thumbs + '</ul>' +
      '<div class="vct-cmp-bar__actions">' +
        (list.length < 2 ? '<p class="vct-cmp-bar__hint">' + esc(t.pickMore) + '</p>' : '') +
        '<button type="button" class="vct-btn vct-btn--brand vct-btn--sm" data-vct-cmp-open' + (list.length < 2 ? ' disabled' : '') + '>' + esc(t.compareN.replace('{n}', list.length)) + '</button>' +
        '<button type="button" class="vct-cmp-bar__clear" data-vct-cmp-clear>' + esc(t.clear) + '</button>' +
      '</div>' +
      '<p class="vct-cmp-bar__flash" aria-live="polite"></p>';
    el.hidden = false;
    document.documentElement.classList.add('vct-cmp-open');
  }
  function flash(msg) {
    renderBar();
    var f = bar && bar.querySelector('.vct-cmp-bar__flash');
    if (!f) return;
    f.textContent = msg;
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { f.textContent = ''; }, 3500);
  }

  /* ---- Table --------------------------------------------------------------- */

  var dialog = null;
  var lastFocus = null;
  function openTable() {
    var list = load();
    if (list.length < 2) return;
    lastFocus = document.activeElement;
    if (!dialog) {
      dialog = document.createElement('div');
      dialog.className = 'vct-cmp-dialog';
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', 'vct-cmp-title');
      document.body.appendChild(dialog);
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-vct-cmp-close]')) closeTable();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && dialog && !dialog.hidden) closeTable();
      });
    }
    var rows = ROWS.filter(function (key) {
      return list.some(function (p) { return cell(key, p.s) != null; });
    });
    var head = '<tr><td></td>' + list.map(function (p) {
      return '<th scope="col"><a href="' + esc(p.u) + '" class="vct-cmp-table__product">' +
        '<span class="vct-cmp-table__img"><img src="' + esc(p.i) + '" alt="" width="120" height="120" loading="lazy"></span>' +
        '<span class="vct-cmp-table__name">' + esc(p.t) + '</span></a></th>';
    }).join('') + '</tr>';
    var body = '<tr><th scope="row">' + esc(t.price) + '</th>' + list.map(function (p) {
      return '<td><strong class="vct-cmp-table__price">' + esc(p.p) + '</strong></td>';
    }).join('') + '</tr>';
    rows.forEach(function (key) {
      var vals = list.map(function (p) { return cell(key, p.s); });
      var differs = vals.some(function (v) { return v !== vals[0]; });
      body += '<tr' + (differs ? ' class="is-diff"' : '') + '><th scope="row">' + esc(t[key]) + '</th>' + vals.map(function (v) {
        return '<td>' + (v == null ? '<span class="vct-cmp-table__none">–</span>' : esc(v)) + '</td>';
      }).join('') + '</tr>';
    });
    body += '<tr class="vct-cmp-table__cta"><th scope="row"></th>' + list.map(function (p) {
      return '<td><a class="vct-btn vct-btn--outline vct-btn--sm" href="' + esc(p.u) + '">' + esc(t.view) + '</a></td>';
    }).join('') + '</tr>';
    dialog.innerHTML =
      '<div class="vct-cmp-dialog__panel">' +
        '<header class="vct-cmp-dialog__head"><h2 id="vct-cmp-title">' + esc(t.title) + '</h2>' +
        '<button type="button" class="vct-cmp-dialog__close" data-vct-cmp-close aria-label="' + esc(t.close) + '">×</button></header>' +
        '<div class="vct-cmp-dialog__scroll"><table class="vct-cmp-table" style="--vct-cmp-cols:' + list.length + '"><thead>' + head + '</thead><tbody>' + body + '</tbody></table></div>' +
        '<p class="vct-cmp-dialog__note">' + esc(t.note) + '</p>' +
      '</div>';
    dialog.hidden = false;
    document.documentElement.classList.add('vct-cmp-locked');
    var close = dialog.querySelector('[data-vct-cmp-close]');
    if (close) close.focus();
  }
  function closeTable() {
    if (!dialog) return;
    dialog.hidden = true;
    document.documentElement.classList.remove('vct-cmp-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---- Start --------------------------------------------------------------- */

  function init() {
    syncToggles();
    renderBar();
    /* Cards come back after filtering or paging */
    if ('MutationObserver' in window) {
      var timer = null;
      new MutationObserver(function () {
        if (!timer) timer = setTimeout(function () { timer = null; syncToggles(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
